import { Trees, UtensilsCrossed, ParkingSquare, Sparkles } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const reasonIcons = [Trees, Sparkles, UtensilsCrossed, ParkingSquare];

export function Why() {
  const { t } = useI18n();
  const stats = t.why.stats;
  const reasons = t.why.reasons.map((r, i) => ({ ...r, icon: reasonIcons[i] ?? Trees }));
  return (
    <section id="waarom" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid gap-12 md:grid-cols-12 md:gap-16">
          <div className="md:col-span-5">
            <p className="font-mono-cinema text-[10px] text-gold">{t.why.eyebrow}</p>
            <h2 className="mt-5 font-display text-4xl font-medium leading-[1.05] md:text-5xl lg:text-6xl">
              {t.why.title}
            </h2>
            <p className="mt-6 text-foreground/70 md:text-lg">
              {t.why.body}
            </p>
          </div>

          <div className="md:col-span-7">
            <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-border bg-border">
              {stats.map((s, i) => (
                <div key={`${s.suffix}-${i}`} className="bg-card p-6 md:p-8">
                  <div className="font-display text-4xl font-medium leading-none text-gold md:text-5xl">
                    {s.value}
                  </div>
                  <div className="mt-2 font-display text-sm text-foreground/85">{s.suffix}</div>
                  <div className="mt-1 text-xs text-foreground/75">{s.caption}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-2 lg:grid-cols-4">
          {reasons.map((it) => (
            <article
              key={it.title}
              className="group relative bg-card p-7 transition-colors hover:bg-secondary md:p-8"
            >
              <div className="mb-6 flex h-11 w-11 items-center justify-center rounded-lg bg-gold/10 text-gold transition-colors group-hover:bg-gradient-gold group-hover:text-gold-foreground">
                <it.icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-lg font-medium md:text-xl">{it.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground/65">
                {it.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
